//TODO: Add any additional values if they appear during development and maybe rename to something more suitable
export enum Type {
    Empty = "-",
    H = "H",
    L = "L",
}

//TODO: Add any additional values if they appear during development and maybe rename to something more suitable
export enum SubType1Letter {
    A = "A",
    D = "D",
    H = "H",
    L = "L",
}

//TODO: Add any additional values if they appear during development and maybe rename to something more suitable
export enum SubType2Letter {
    Empty = "--",
    Cs = "CS",
    Dc = "DC",
    Dn = "DN",
    Hh = "HH",
    Hl = "HL",
    Mh = "MH",
    Mr = "MR",
    Wh = "WH",
    hl = "hl",
    Ah = "AH",
}
